  <template>
    <transition name="fade">
      <div
        v-if="notification.visible.value"
        class="fixed top-4 right-4 px-4 py-2 rounded-lg shadow-lg text-white" style="z-index: 9999;"
        :class="{
          'bg-green-500': notification.type.value === 'success',
          'bg-red-500': notification.type.value === 'error',
        }"
      >
        {{ notification.message }}
      </div>
    </transition>
  </template>
  
  <script setup>
  import { useNotificationStore } from "../shared/store/notification";
  import { storeToRefs } from "pinia";
  
  const notification = storeToRefs(useNotificationStore());

  </script>
  
  <style>
  /* Animação de fade-in e fade-out */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  </style>
  